<template>
  <div class="wg-row">
    <wg-modal
      :width="'400px'"
      v-if="showConfirmationModal"
      @closeModal="showConfirmationModal = false;"
    >
      <div slot="body" class="wg-row no-select" style="justify-content:center;">
        <div
          class="com-anm22-app-text-xl"
          style="margin-bottom:20px;"
        >{{ $anm22.strLang(lang, 'Do you want to cancel these orders?', 'Vuoi davvero cancellare questi ordini?') }}</div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div
          class="com-anm22-app-text-xl"
          style="margin-bottom:20px;color:red;"
        >{{ $anm22.strLang(lang, 'Data can not be restored later.', 'I dati non possono essere ripristinati in seguito.') }}</div>
        <div class="wg-row" style="flex-wrap:nowrap;align-items:center;justify-content:center;">
          <input
            type="button"
            class="com-anm22-button-red"
            style="width:50px;margin-right:20px;"
            :value="$anm22.strLang(lang, 'Yes', 'Si')"
            @click="confirm();showConfirmationModal = false;"
          >
          <input
            type="button"
            style="width:50px;"
            :value="$anm22.strLang(lang, 'No', 'No')"
            @click="showConfirmationModal = false;"
          >
        </div>
      </div>
    </wg-modal>
    <div class="com-anm22-page-title" style="font-size:24px;">
      Database
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="com-anm22-app-text-xl">
      {{ $anm22.strLang(lang, 'Delete selected data', 'Cancella dati selezionati') }}
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
      <div class="wg-col wg-xs-1">
        <div class="com-anm22-app-text-xl">
          {{ $anm22.strLang(lang, 'From', 'Da') }}
        </div>
      </div>
      <div class="wg-col wg-xs-11">
        <input 
            class="com-anm22-app-input-date"
            type="date" 
            v-model="from">
      </div>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
      <div class="wg-col wg-xs-1">
        <div class="com-anm22-app-text-xl">
          {{ $anm22.strLang(lang, 'To', 'A') }}
        </div>
      </div>
      <div class="wg-col wg-xs-11">
        <input 
            class="com-anm22-app-input-date"
            type="date" 
            v-model="to">
      </div>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
      <select class="com-anm22-app-select" v-model="payed" style="width:150px;">
        <option 
            :value="0">
          {{ $anm22.strLang(lang, 'Not payed', 'Non pagati') }}
        </option>
        <option 
            :value="1">
          {{ $anm22.strLang(lang, 'Payed', 'Pagati') }}
        </option>
        <option 
            :value="'all'">
          {{ $anm22.strLang(lang, 'All', 'Tutti') }}
        </option>
      </select>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
      <select class="com-anm22-app-select" v-model="receipt" style="width:150px;">
        <option 
            :value="0">
          {{ $anm22.strLang(lang, 'No receipt', 'Senza ricevuta') }}
        </option>
        <option 
            v-for="(obj, key, index) in $anm22.tableClasses.worldReceiptType().getAll()"
            :key="'receipt-opt-'+index"
            :value="key">
          {{ obj[lang] }}
        </option>
      </select>
    </div>
    <div class="vertical-height-div" style="height:20px;"></div>
    <div class="wg-row">
      <input 
          type="button" 
          :value="$anm22.strLang(lang, 'Delete', 'Cancella')" 
          @click="showConfirmationModal = true;">
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    timezone: {
      type: String,
      default: "Europe/Rome"
    }
  },
  data() {
    return {
      from: null,
      to: null,
      payed: 0,
      receipt: 0,
      showConfirmationModal: false
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      licenseSelected: state => state.licenseSelected,
      windowWidth: state => state.windowWidth,
      windowHeight: state => state.windowHeight,
      isOffline: state => state.offline.isOffline
    }),
    license() {
      return this.$store.getters['foodLicenses/getByHash'](this.licenseSelected);
    },
  },
  methods: {
    confirm() {
      this.$http
        .post('settings/delete-orders', {
          from_date: this.from,
          to_date: this.to,
          payed: this.payed,
          receipt: this.receipt
        })
        .then(response => {
          this.$anm22.eventBus.$emit('wg-modal-close');
          if(response.data.success) {
            this.$anm22.eventBus.$emit("world-headbar-show-message", {
              text: this.$anm22.strLang(
                this.lang,
                "Data deleted successfully",
                "Dati cancellati correttamente"
              ),
              type: "confirm"
            });
          } else {
            this.$anm22.eventBus.$emit("world-headbar-show-message", {
              text: this.$anm22.strLang(
                this.lang,
                "There was an error during deletion. Try again.",
                "C'è stato un errore durante la cancellazione. Riprovare."
              ),
              type: "alarm"
            });
          }
        })
        .catch(e => {});
    }
  },
  created() {
    // Blocco l'accesso se ho un permesso di basso livello
    if(this.permission > 2) {
      this.$router.push('/').catch(e => console.log(e));
      return;
    }
    this.from = this.$moment().tz(this.timezone).format('YYYY-MM-DD');
    this.to = this.$moment().tz(this.timezone).format('YYYY-MM-DD');
  }
}
</script>

<style lang="scss" scoped>

</style>
